export const resorts = [
  {
    id: '1',
    name: 'Jurasówka',
    country: 'Poland',
    place: 'Siemiechów',
    lat: 49.872,
    long: 20.898,
    alt: '390 - 450',
    lifts: [
      {
        type: 'button',
        count: 2,
      }
    ],
    trailRatings: [ 'green', 'blue', 'red' ],
    bunnySlope: true,
    www: 'https://jurasowka.pl',
    phone: '14 625 80 91',
    address: '33-181 Siemiechów 359',
    maplink: 'https://pl.frame.mapy.cz/s/cozupugovu',
    shortname: 'jurasowka',
    description: `
      Jurasówka to niewielki rodzinny ośrodek, „zagubiony” wśród wzniesień i lasów Pogórza Ciężkowickiego, to jednak zawsze doskonale przygotowany do sezonu zimowego.          
      Na odwiedzających czekają niezwykle ciekawe zajęcia grupowe oraz szkolenia, możliwość organizacji imprez okolicznościowych takich jak urodziny, a także imprez firmowych. W Ośrodku Jurasówka każdy znajdzie coś dla siebie.          
      Dzięki wprowadzeniu oferty letniej, w ośrodku pojawiła się cała masa nowych atrakcji takich jak: rozbudowana część wodna, quady z wydzielonym torem quadowym, specjalistyczne sterowane modele, którymi można zarówno pływać jak i jeździć oraz długa tyrolka z zachwycającymi widokami.
      Wypożyczalnia sprzętu, serwis, szkoła narciarska, bar, a także parking nie znajdują się przy dolnej, a przy górnej stacji. To stąd wiodą dwie trasy – średnio-trudna, 350-metrowa „jedynka” oraz nieco łagodniejsza, spadająca malowniczym łukiem „dwójka”. Stok szkoleniowy i nieco ponad stumetrowy orczyk odnajdziemy w pobliżu górnej stacji.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe style="width: 100%; border: none;" src="//streaming.km-net.pl/hls/Jurasowka2" width="960" height="720" allowfullscreen="allowfullscreen">Loading the player ...</iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe style="width: 100%; border: none;" src="//streaming.km-net.pl/hls/Jurasowka1" width="960" height="720" allowfullscreen="allowfullscreen">Loading the player ...</iframe>`
      },
    ]
  },
  {
    id: '2',
    name: 'Pod Dziedzicem',
    country: 'Poland',
    place: 'Gogołów',
    lat: 49.838,
    long: 21.523,
    alt: '360 - 440',
    lifts: [ 
      {
        type: 'button',
        count: 2,
      }
    ],
    trailRatings: [ 'green', 'blue' ],
    bunnySlope: true,
    www: 'https://www.gogolow-narty.pl',
    phone: '17 277 79 09',
    address: '38-131 Gogołów 20c, ',
    maplink: 'https://pl.frame.mapy.cz/s/conusagago',
    shortname: 'gogolow',
    description: `
      W Gogołowie znajdują się 2 wyciągi talerzykowe o długości 500 m, a trasa zjazdowa liczy 600 – 700 m. Jest także wyciąg z niskim prowadzeniem liny o długości 180 m i trasa zjazdowa licząca 200 - 300 m.
      Trasy są otwarte codziennie w godzinach od 10 do 21. Są oświetlone, naśnieżane i ratrakowane.
      Najmłodsi mają do dyspozycji specjalną trasę zjazdową  przy górnej stacji wyciągów. Można tutaj spotkać również tych starszych; początkujących narciarzy. W górnej części stoku znajduje się także trasa do zjazdu pontonami (tubing) oraz karuzela z pontonami.
      Przy dolnej i górnej stacji wyciągów znajdują się wypożyczalnie sprzętu sportowego. Można tutaj także skorzystać z usług serwisu narciarskiego. Początkujący narciarze czy snowboardziści mogą skorzystać ze szkółek narciarskich bądź z usług indywidualnych instruktorów.
      Gogołów to wieś w Polsce położona w województwie podkarpackim, liczy około 1500 mieszkańców. Leży nad potokiem Gogołówka. Przechodzi tędy droga Frysztak-Klecie. W latach 1954–1961 wieś należała i była siedzibą władz gromady Gogołów, po jej zniesieniu w gromadzie Glinik Górny. W latach 1975–1998 miejscowość administracyjnie należała do województwa rzeszowskiego.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe style="width: 283px; height: 300px;" src="//player.webcamera.pl/index.php?id=gogolow_cam_f20d7a" width="300" height="150" allowfullscreen="allowfullscreen"></iframe>`,
      },
      {
        type: 'iframe',
        code: `<iframe style="width: 283px; height: 300px;" src="//player.webcamera.pl/index.php?id=gogolow_cam_6a68c6" width="300" height="150" allowfullscreen="allowfullscreen"></iframe>`
      },
    ]
  },
  {
    id: '3',
    name: 'Kiczera Ski',
    country: 'Poland',
    place: 'Puławy',
    lat: 49.495,
    long: 21.934,
    alt: '470 - 630',
    lifts: [ 
      {
        type: 'chairs',
        count: 1,
      },
      {
        type: 'button',
        count: 2,
      }
    ],
    trailRatings: [ 'green', 'blue', 'red' ],
    bunnySlope: true,
    www: 'https://www.kiczeraski.pl',
    phone: '13 435 90 01',
    address: '38-480 Puławy 16',
    maplink: 'https://pl.frame.mapy.cz/s/dacorurodo',
    shortname: 'kiczera',
    description: `
      Ośrodek Sportów Zimowych KiczeraSki w Puławach Górnych to ośrodek narciarski położony na północnym zboczu Kiczery (640 m n.p.m.) w Paśmie Bukowicy w Beskidzie Niskim na terenie powiatu krośnieńskiego w gminie Rymanów.
      W skład kompleksu wchodzą wyciągi: 2 - osobowy wyciąg krzesełkowy o długości 900 m i przewyższeniu 170 m oraz przepustowości 1200 osób na godzinę, czas przejazdu – 5 min 40 sek. Wyciąg talerzykowy o długości 420 m i przewyższeniu 90 m oraz przepustowości 450 osób na godzinę, obsługujący również snowpark. Tzw. wyrwirączka „Babylift” o długości 120 m i przewyższeniu 15 m oraz przepustowości 200 osób na godzinę.
      Do dyspozycji fanów białego szaleństwa oddany jest wyciąg krzesełkowy oraz talerzykowy. Trasy zjazdowe o zróżnicowanym poziomie zaawansowania, trasa skiturowa, snowpark, restauracja Amadeus, wypożyczalnia oraz Ski szkółka.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe style="border: 0;" src="//player.webcamera.pl/kiczeraski_cam_2b0ef4" width="800" height="450" allowfullscreen="allowfullscreen"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe style="border: 0;" src="//player.webcamera.pl/kiczeraski_cam_82a692" width="800" height="450" allowfullscreen="allowfullscreen"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe style="border: 0;" src="//player.webcamera.pl/kiczeraski_cam_0b1dc1" width="800" height="450" allowfullscreen="allowfullscreen"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe style="border: 0;" src="//player.webcamera.pl/kiczeraski_cam_73be2c" width="800" height="450" allowfullscreen="allowfullscreen"></iframe>`
      },
    ]
  },
  {
    id: '4',
    name: 'Słotwiny Arena',
    country: 'Poland',
    place: 'Krynica-Zdrój',
    lat: 49.431,
    long: 20.932,
    alt: '700 - 860',
    lifts: [ 
      {
        type: 'chairs',
        count: 1,
      },
      {
        type: 'button',
        count: 2,
      }
    ],
    trailRatings: [ 'green', 'blue', 'red' ],
    bunnySlope: true,
    www: 'https://www.slotwinyarena.pl',
    phone: '512 409 905',
    address: '33-380 Krynica-Zdrój, ul. Słotwińska 51',
    maplink: 'https://pl.frame.mapy.cz/s/mudakecera',
    shortname: 'slotwiny',
    description: `
      Ośrodek narciarski i rowerowy Słotwiny Arena w Krynicy położony w Słotwinach, dzielnicy Krynicy-Zdroju, w Beskidzie Sądeckim na południowo-wschodnim zboczu Drabiakówki (ok. 896 m n.p.m). Drabiakówka znajduje się na bocznym grzbiecie Pasma Jaworzyny, który w tym miejscu opadając w kierunku Przełęczy Krzyżowej (ok. 770 m) oddziela Słotwiny od osiedla Czarny Potok. Tuż obok Słotwiny Arena (na północny zachód) znajduje się Kompleks Narciarski Słotwiny w Krynicy, również na zboczu tego samego grzbietu.
      Latem działa Bike Park z 4 trasami rowerowymi oraz Wieża widokowa ze ścieżką w koronach drzew. 
      Obiekt oferuje taras, bezpłatny prywatny parking, bar oraz dojazd do budynku na nartach. Odległość ważnych miejsc od obiektu: Muzeum Nikifora – 3,4 km. Do dyspozycji Gości przygotowano takie udogodnienia, jak restauracja, obsługa pokoju, bankomat. Odległość ważnych miejsc od obiektu: PKP Krynica Zdrój – 4,5 km.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/slotwinyarena" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/slotwinyarena-2" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/slotwiny-arena-slotwinka" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
    ]
  },
  {
    id: '5',
    name: 'Kasina Ski',
    country: 'Poland',
    place: 'Kasina Wielka',
    lat: 49.717,
    long: 20.160,
    alt: '580 - 865',
    lifts: [ 
      {
        type: 'chairs',
        count: 1,
      },
      {
        type: 'button',
        count: 1,
      }
    ],
    trailRatings: [ 'green', 'blue', 'red', 'black' ],
    bunnySlope: true,
    www: 'https://www.kasinaski.pl',
    phone: '18 506 51 00',
    address: '34-741 Kasina Wielka 672',
    maplink: 'https://pl.frame.mapy.cz/s/palasememo',
    shortname: 'kasina',
    description: `
      Kasina Ski & Bike Park to ukochana przestrzeń pasjonatów sportów zimowych i letnich. 
      Ośrodek powstał ponad 40 lat temu w miejscu, znanym w okolicy z najdłużej utrzymującego się śniegu – zwanym kiedyś Śnieżną Górą, a obecnie Śnieżnicą. To właśnie tutaj, z wielkiej pasji do nart, powstał ośrodek narciarski, który od kilku lat latem, gdy stopnieją śniegi, przekształca się w Bike Park.
      Wspaniałe imprezy plenerowe, zawody ogólnopolskie, bogata oferta zimowa i letnia oraz serce, które wkładamy w codzienną pracę sprawiają, że Kasina stała się symbolem świetnej, sportowej zabawy na świeżym powietrzu niezależnie od wieku, kondycji fizycznej oraz pory roku.
      To jedno z pięciu wyjątkowych miejsc na turystycznej mapie Polski, obok Czarnego Gronia, Kurzej Góry, Skolnity i Słotwiny Arena, należących do Grupy Pingwina.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/kasina" width="400" height="225" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/kasina-2" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/kasinaski-stacja-narciarska" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`,
      }
    ]
  },
  {
    id: '6',
    name: 'Witów Ski',
    country: 'Poland',
    place: 'Witów',
    lat: 49.320,
    long: 19.818,
    alt: '830 - 975',
    lifts: [ 
      {
        type: 'chairs',
        count: 1,
      },
      {
        type: 'button',
        count: 2,
      }
    ],
    trailRatings: [ 'green', 'blue' ],
    bunnySlope: true,
    www: 'https://www.witow-ski.pl',
    phone: '18 207 13 30',
    address: '34-512 Witów 205c',
    maplink: 'https://pl.frame.mapy.cz/s/dovuzuluge',
    shortname: 'witow',
    description: `
      Stacja Narciarska Witów-Ski w Witowie położony jest w gminie Kościelisko na wschodnich zboczach grzbietu Wierchów Orawicko-Witowskich między Magurą Witowską a Masnakovą.
      W skład kompleksu wchodzą: 4-osobowa kolej krzesełkowa firmy Doppelmayr Garaventa Group z taśmą rozpędową, o długości 1000 m i przepustowości 2200 osób na godzinę i przewyższeniu – 150 m, czas wjazdu – 6 minut, wyciąg talerzykowy o długości 120 m, przewyższeniu 30 m i przepustowości 300 osób na godzinę.
      Stacja narciarska Witów Ski znajduje się w niewielkiej odległości od takich atrakcji turystycznych jak: Dolina Chochołowska, Dolina Kościeliska, baseny termalne w Chochołowie i w Oravicach (Meander Park).
      Witowianka to restauracja samoobsługowa dla osób, które chcą zjeść przede wszystkim szybko i smacznie. Restauracja jest położona zaraz obok dolnej stacji Witów Ski. 
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe width="600" height="300" src="//player.webcamera.pl/skywind_cam_0e8c2a" allowfullscreen style="border:0"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe width="600" height="300" src="//player.webcamera.pl/skywind_cam_3e61cc" allowfullscreen style="border:0"></iframe>`
      }
    ]
  },
  {
    id: '7',
    name: 'Arena Narciarska Jaworki - Homole',
    country: 'Poland',
    place: 'Jaworki',
    lat: 49.401,
    long: 20.558,
    alt: '600 - 715',
    lifts: [
      {
        type: 'chairs',
        count: 1,
      },
      {
        type: 'button',
        count: 1,
      }
    ],
    trailRatings: [ 'blue', 'red' ],
    bunnySlope: true,
    www: 'https://arenanarciarska.pl',
    phone: '785 187 667',
    address: '34-460 Jaworki, Zaskalskie 16',
    maplink: 'https://pl.frame.mapy.cz/s/hogedeboge',
    shortname: 'jaworki',
    description: `
      Ośrodek położony jest w Jaworkach jednym z najpiękniejszych zakątków Polski, na styku dwóch pasm górskich – pasma Radziejowej i Małych Pienin. Położenie to, powoduje, że panuje tutaj wyjątkowy, służący zdrowiu mikroklimat oraz niezwykłe bogactwo form krajobrazu.
      Atrakcje regionu: Klub Muzyczna Owczarnia, Architektura świecka i sakralna, Stadnina koni Bukowinki,  Rezerwat przyrody Wąwóz Homole, Rezerwat Przyrody Zaskalskie – Bodnarówka, Rezerwat Przyrody Biała Woda, Rezerwat Przyrody Wysokie Skałki, Stadnina koni Rajd, kuligi zaprzęgami konnymi.
      Arena Narciarska o łącznej powierzchni 27 ha graniczy od wschodu z rezerwatem Zaskalskie Bodnarówka, a od zachodu z rezerwatem Wąwóz Homole. Wyciągi położone są na północnym stoku Bukowinek w dolinie potoku Skalskie. W ośrodku narciarskim do dyspozycji narciarzy i snowboardzistów funkcjonują 2 wyciągi orczykowe oraz kolej linowa 2-osobowa.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe src="https://arenanarciarska.aztv.pl/arenanarciarska.php?width=680&amp;height=385" width="680" height="385" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" style="border:0;" scrolling="no"></iframe>`
      }
    ]
  },
  {
    id: '8',
    name: 'Palenica',
    country: 'Poland',
    place: 'Szczawnica',
    lat: 49.422,
    long: 20.478,
    alt: '450 - 730',
    lifts: [ 
      {
        type: 'chairs',
        count: 2,
      },
      {
        type: 'button',
        count: 2,
      }
    ],
    trailRatings: [ 'green', 'blue', 'red' ],
    bunnySlope: true,
    www: 'https://www.pkl.pl/palenica',
    phone: '22 444 66 66',
    address: '34-460 Szczawnica, ul. Główna 7',
    maplink: 'https://pl.frame.mapy.cz/s/kehepabaco',
    shortname: 'palenica',
    description: `
      Wyciąg krzesełkowy Palenica. Trasa wyciągu pokonuje odległość 777 metrów, a różnica wysokości między dolną a górną stacją kolejki to 263 metry. Kolejka porusza się po linie wspieranej przez dziesięć podpór trasowych. Wyciąg składa się z 54 krzesełek mieszczących jednocześnie 4 osoby. Czas przejazdu w jedną stronę wynosi od 4 do 5 minut, a zdolność przewozowa kolejki to aż 2200 osoby na godzinę. 
      Palenica jest także świetnym punktem dla wycieczek pieszych. Prowadzi stąd m.in. szlak turystyczny na najwyższy szczyt Pienin – Wysoką. Trasa biegnie przez widokowy Wysoki Wierch, dalej Durbaszkę na Wysoką, skąd można zejść do Jaworek przez Wąwóz Homole lub Przełęcz Rozdziela.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/szczawnica-palenica" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
            {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/palenica-szafranowka" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      }
    ]
  },
  {
    id: '9',
    name: 'Kalatówki',
    country: 'Poland',
    place: 'Zakopane',
    lat: 49.258,
    long: 19.965,
    alt: '1200 - 1280',
    lifts: [ 
      {
        type: 'button',
        count: 1,
      }
    ],
    trailRatings: [ 'blue' ],
    bunnySlope: false,
    www: 'https://www.kalatowki.pl',
    phone: '18 20 636 44',
    address: '34-500 Zakopane, Kalatówki',
    maplink: 'https://pl.frame.mapy.cz/s/lefuhogamo',
    shortname: 'kalatowki',
    description: `
      Obok Hotelu Górskiego PTTK Kalatówki zlokalizowany jest orczykowy wyciąg narciarski. Wyciąg o długości 400 m znajduje się w Suchym Żlebie. Warunki naturalne stoku  sprzyjają długiemu utrzymywaniu się naturalnej pokrywy śnieżnej. Stok łatwy do jazdy, utrzymywany ratrakiem. Dysponujemy wykwalifikowaną kadrą instruktorską. W Hotelu znajduje się wypożyczalnia sprzętu narciarskiego i snowboardowego oraz serwis. Dla dzieci przygotowaliśmy przedszkole narciarskie.
      Na Kalatówkach szczególnie dobrze czują się młodzi narciarze. Na bezpiecznym stoku czeka na nich moc atrakcji. Dzieciaki uczą się pod czujnym okiem doświadczonych instruktorów korzystając ze specjalnie przygotowanego przedszkola w Suchym Żlebie. Już po kilku dniach ćwiczeń poprzez zabawę maluchy śmigają wesoło między barwnymi figurkami zwierzątek porozstawianych jak slalomowe tyczki na specjalnie wydzielonej dla dzieci części stoku.
    `
  },
  {
    id: '10',
    name: 'Stacja Narciarska Wierchomla',
    country: 'Poland',
    place: 'Wierchomla Mała',
    lat: 49.424,
    long: 20.831,
    alt: '590 - 890',
    lifts: [ 
      {
        type: 'chairs',
        count: 1,
      },
      {
        type: 'button',
        count: 3,
      }
    ],
    trailRatings: [ 'green', 'blue', 'red' ],
    bunnySlope: true,
    www: 'https://www.wierchomla.com.pl/',
    phone: '18 414 31 30',
    address: '33-350 Wierchomla Mała 42',
    maplink: 'https://pl.frame.mapy.cz/s/hosebucubu',
    shortname: 'wierchomla',
    description: `
      Stacja narciarska położona jest w Beskidach, 12 km od Piwnicznej - Zdroju. Unikalne warunki narciarskie stacja zawdzięcza specyficznym warunkom klimatycznym - śnieg utrzymuje się tutaj długo (od listopada do kwietnia), a temperatura jest średnio o 4 stopnie niższa, niż w pobliskich miejscowościach.
      To jedna z największych rodzinnych stacji  narciarskich w Polsce i jest zaliczana do czołówki najdynamiczniej rozwijających się ośrodków narciarskich w kraju. Trasy zjazdowe o różnym stopniu trudności, z czego część jest oświetlona i umożliwia szusowanie do późnych godzin wieczornych.
      Narciarze i snowboardziści mogą korzystać z wyciągów krzesełkowych oraz orczykowych. Bogata i różnorodna infrastruktura umożliwia aktywny i ciekawy wypoczynek rodzinom. Na terenie stacji narciarskiej znajduje się wypożyczalnia, serwis oraz przechowalnia sprzętu narciarskiego. Dla początkujących adeptów narciarstwa i snowboardu oferowane są kursy nauki jazdy na nartach w licencjonowanej szkole narciarskiej. 
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/wierchomla" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/wierchomla3" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/wierchomla4" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/wierchomla-stonoga" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://wierchomla-szalas.webcamera.pl/" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://wierchomla-toczek-gorna-stacja.webcamera.pl/" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://wierchomla-toczek-dolna-stacja.webcamera.pl/" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      }
    ]
  },  {
    id: '11',
    name: 'Sport Arena Myślenice',
    country: 'Poland',
    place: 'Myślenice',
    lat: 49.803,
    long: 19.950,
    alt: '380 - 610',
    lifts: [
      {
        type: 'chairs',
        count: 1,
      },
      {
        type: 'button',
        count: 1,
      }
    ],
    trailRatings: [ 'red' ],
    bunnySlope: true,
    www: 'https://zima.sportarenamyslenice.pl',
    phone: '12 357 22 31',
    address: '32-400 Myślenice, ul. Jodłowa 1f',
    maplink: 'https://pl.frame.mapy.cz/s/jokometefu',
    shortname: 'myslenice',
    description: `
      Sport Arena Myślenice to stacja narciarska w Beskidzie Wyspowym na górze Chełm. Znajdują się tam 2 trasy narciarskie o dł. 855 m i 1100 m. Jedna z nich posiada homologację FIS, obie są oświetlone, naśnieżane oraz ratrakowane. Na szczycie Góry znajduje się orczyk talerzykowy o dł. 150 m. Do odwiedzin kompleksu zachęcają piękne widoki na Myślenice i panoramę Krakowa. Dla osób początkujących, chcących rozpocząć swoją przygodę ze sportami zimowymi, przygotowano specjalną „Górkę Wrażeń" zlokalizowaną w dolnej części Zarabia, tuż przy krytym lodowisku, z przenośnikiem taśmowym o dł. 84 m. W skład Kompleksu wchodzą wypożyczalnie, szkółka narciarska, serwis, kryte lodowisko, restauracja i karczma.
      Przy dolnej stacji wyciągu znajduje się wypożyczalnia i serwis narciarski, przeszklony drink-bar, bezpłatny parking o pojemności 200 samochodów. Przy górnej stacji wyciągu znajdują się placówka GOPR
      szkoła narciarska.
      Karczma na szczycie góry Chełm, może pomieścić 120 osób, a wraz z podcieniami – 300 osób.
      Na szczycie góry Chełm znajduje się wieża widokowa. Jest jedną z największych atrakcji atrakcją ośrodka. Z jej platformy można obserwować panoramę Myślenic, a w pogodny dzień także Beskidów i Gorców. W sprzyjających warunkach dojrzeć Tatry.
    `,
    webcams: [
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/mysleniceski2" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/mysleniceski" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/mysleniceski3" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/mysleniceski5" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      },
      {
        type: 'iframe',
        code: `<iframe src="https://imageserver.webcamera.pl/umiesc/mysleniceski4" width="800" height="450" border="0" frameborder="0" scrolling="no"></iframe>`
      }
    ]
  },
]
